import { createFileRoute } from "@tanstack/react-router";

import { OrderDetailPage } from "@/components/Pages/Orders/OrderDetail.page";

export const Route = createFileRoute("/_guard/orders/$orderId")({
  component: OrderDetailPage,
});
